import {
    formatCode,
    formatLabel,
    formatLabelReason,
    formatLabelSource,
    formatMode,
    formatSide,
    formatSigner,
    formatSizeBucket,
    formatUtcDateTime,
    formatValue
} from './diffViewerFormatting';
import { buildRawDifferencesExport } from './diffViewerResponses';

const yesText = "Yes";
const noText = "No";

function formatBoolean(value) {
    return value ? yesText : noText;
}

const differenceColumns = [
    { header: "Employee id", value: (difference) => formatValue(difference.driver.employeeId) },
    { header: "Driver", value: (difference) => formatValue(difference.driver.name) },
    { header: "Reference", value: (difference) => formatValue(difference.driver.reference) },
    { header: "Card number", value: (difference) => formatValue(difference.driver.cardNumber) },
    { header: "Account", value: (difference) => formatValue(difference.driver.accountName) },
    { header: "Member number", value: (difference) => formatValue(difference.driver.memberNumber) },
    { header: "Location", value: (difference) => formatValue(difference.driver.locationName) },
    { header: "Mode", value: (difference) => formatMode(difference.mode) },
    { header: "Infringement", value: (difference) => formatCode(difference.code, difference.subCode) },
    { header: "Field", value: (difference) => formatValue(difference.fieldName) },
    { header: "Side", value: (difference) => formatSide(difference.side) },
    { header: "Occurred at (UTC)", value: (difference) => formatUtcDateTime(difference.occurredAt) },
    { header: "Legacy value", value: (difference) => formatValue(difference.legacyValue) },
    { header: "RE2 value", value: (difference) => formatValue(difference.underTestValue) },
    { header: "Signed gap, legacy - RE2 (seconds)", value: (difference) => formatValue(difference.secondsDifference) },
    { header: "Counterpart at (UTC)", value: (difference) => formatUtcDateTime(difference.counterpartOccurredAt) },
    { header: "Label", value: (difference) => formatLabel(difference) },
    { header: "Label reason", value: (difference) => formatLabelReason(difference) },
    { header: "Label source", value: (difference) => formatLabelSource(difference) },
    { header: "Signed off by", value: (difference) => formatSigner(difference.signOff) },
    { header: "Signed off at (UTC)", value: (difference) => formatUtcDateTime(difference.signOff?.signedOffAt) },
    { header: "Work item", value: (difference) => formatValue(difference.signOff?.workItemId) },
    { header: "Provisional", value: (difference) => formatBoolean(difference.isProvisional) },
    { header: "Signature", value: (difference) => formatValue(difference.signature) }
];

const groupColumns = [
    { header: "Signature", value: (group) => formatValue(group.signature) },
    { header: "Mode", value: (group) => formatMode(group.mode) },
    { header: "Infringement", value: (group) => formatCode(group.code, group.subCode) },
    { header: "Field", value: (group) => formatValue(group.fieldName) },
    { header: "Side", value: (group) => formatSide(group.side) },
    { header: "Gap size", value: (group) => formatSizeBucket(group.sizeBucket) },
    { header: "Count", value: (group) => formatValue(group.count) }
];

function buildSheet(name, columns, rows) {
    return {
        name: name,
        headers: columns.map((column) => column.header),
        rows: rows.map((row) => columns.map((column) => column.value(row)))
    };
}

export function buildDiffViewerSheets(differences, groups) {
    return [
        buildSheet("Differences", differenceColumns, differences),
        buildSheet("Groups", groupColumns, groups)
    ];
}

export function buildDiffViewerJson(response, filters) {
    return JSON.stringify(buildRawDifferencesExport(response, filters), null, 2);
}

// A download with no known period is named for its mode alone rather than for a range of nulls.
export function buildDiffViewerFileName(differencesModel, extension) {
    if (differencesModel.from == null || differencesModel.to == null) {
        return `rules-engine-diffs-${differencesModel.mode}.${extension}`;
    }

    return `rules-engine-diffs-${differencesModel.mode}-${differencesModel.from}-to-${differencesModel.to}.${extension}`;
}
